import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FuseCardModule } from '@fuse/components/card';
import { TranslateModule } from '@ngx-translate/core';
import { ResolutionPipe } from './resolution.pipe';
import { JobCardComponent } from './components/job-card/job-card.component';
import { LocaleDatePipe } from './pipes/locale-date.pipe';
import { LocaleCurrencyPipe } from './pipes/locale-currency.pipe';

@NgModule({
    imports: [
        CommonModule, 
        FormsModule, 
        ReactiveFormsModule,
        MatButtonModule,
        MatIconModule,
        FuseCardModule,
        TranslateModule
    ],
    declarations: [
        ResolutionPipe, 
        JobCardComponent,
        LocaleDatePipe,
        LocaleCurrencyPipe
    ],
    exports: [
        CommonModule, 
        FormsModule, 
        ReactiveFormsModule, 
        TranslateModule,
        ResolutionPipe, 
        JobCardComponent,
        LocaleDatePipe,
        LocaleCurrencyPipe
    ],
})
export class SharedModule {}
